import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Menu, { preloadMenu } from '../components/menu';

interface MenuProcessorElement extends Element {
  props: Element['props'] & {
    slot?: string;
    'data-erom-menu-slot'?: string;
  };
}

const menu: Processor<MenuProcessorElement> = {
  priority: 10,
  name: 'menu',
  test: ({ node }) => !!node.props?.['data-erom-menu-slot'],
  processor: ({ node }) => {
    const slot = node.props['data-erom-menu-slot'];

    // Preload menu data into SWR cache
    if (slot) {
      preloadMenu(slot);
    }

    node.props.slot = slot;
    node.component = Menu as ComponentType;

    return node;
  }
};

export default menu;
